// extracted by mini-css-extract-plugin
module.exports = {"header":"entity_block_content_components-module__header--3WBio"};